import React, { useEffect, useRef } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { listOfDatesByDay } from 'utils/dates';
import { filterObject } from 'utils/helpers';
import widgetRender from './bei-light';
import SliderComponent from '../FeedBackSynthesis/Slider';

function updateChart(widgetObject, dataFilteringRule) {
  widgetObject.detailProperties.dataFiltering = dataFilteringRule;

  widgetRender(widgetObject, 'updateData');
}

const ChartPeerInvest = ({ data, loading, error }) => {
  const d3svg = useRef(false);

  // json parametres de la viz
  const widgetProperties_US342 = {
    generalProperties: {
      chartType: 'barchart', // barchart, pie, linechart
      orientation: 'horizontal', // horizontal, vertical (for XY axis chart)
      direction: 'standard', // standard, opposite
      margin: { top: 50, right: 20, bottom: 100, left: 50 },
      size: { width: '100%', height: '100%' },
      minSize: { width: 420, height: 330 },
      minPlotSize: { width: 100, height: 100 },
      activeClipPath: false,
      errorMsg: 'lorem ipsum'
    },
    detailProperties: {
      dataAggregation: true,
      dimensionFields: ['peer', 'investorType'],
      dimensionFieldsDatatype: ['text', 'text'],
      dimensionFieldsLabel: ['peer', 'investorType'],
      dimensionFieldsFormat: null,
      dimensionFieldsCustomSort: [null],
      dimensionFieldsSortOrder: [null],
      multiDimensionStyle: 'stacked',
      calculationFields: ['count'],
      calculationFieldsLabel: ['count'],
      calculationFieldsDatatype: ['number'],
      calculationFieldsFormat: ['.2'],
      calculationFieldsAdjustPct: false,
      styles: {
        themeScheme: 'beiLightTheme',
        colors: {
          defaultColor: '#002380',
          defaultStrokeColor: '#002380',
          defaultFillColor: '#002380',
          dimensionField: ['investorType'],
          dimensionFieldSortOrder: null,
          dimensionFieldCustomOrder: [
            'Venture Capital',
            'PE',
            'SWF',
            'Mutual Fund',
            'Pension Fund',
            'Hedge Fund',
            'Corporate',
            'Holding Company'
          ],
          dimensionScaleMode: ['categorical'], // categorical, continous
          scaleType: ['scaleOrdinal'], // scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          interpolator: null,
          scheme: [
            '#002380',
            '#1E90A6',
            '#75C8C4',
            '#A3E3C0',
            '#CFFCD2',
            '#F8FEB1',
            '#F2ED88',
            '#FCECBD'
          ],
          schemeType: 'colorArray' // colorArray, colorGradientArray
        },
        textures: {
          active: false,
          defaultTexture: ''
        }
      },
      XYChart: {
        includeOrigin: true, // used for barchart / linechart
        linearGridline: true,
        categoricalGridline: false,
        linearAxis: false,
        linearAxisLine: false,
        linearAxisLabel: true,
        linearAxisLabelFormat: '.0f',
        linearAxisTick: false,
        linearAxisMinMaxExtendFactor: [1, 1.5],
        linearAxisTicksNumber: 3,
        linearAxisMinMaxOnDataset: true,
        categoricalAxis: true,
        categoricalAxisLabel: true,
        categoricalAxisTick: false,
        categoricalAxisLabelFormat: null,
        categoricalAxisLabelVPadding: 10,
        categoricalAxisLabelTextWrapWidth: 150,
        categoricalAxisLabelTextWrapLineHeight: 1.2,
        categoricalAxisLabelTextShift: 1.6,
        categoricalAxisLabelTextAnchor: 'middle',
        barPadding: 0.4, // value between 0 and 1
        barRadius: 0, // value in px
        barRadiusPosition: 'all', // all, top, bottom
        barGroupPadding: 0.7, // value between 0 and 1
        barBandwithReduction: 0
      },
      axis: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '200',
        color: '#979797',
        altColor: '#000000',
        labelColor: '#65676a',
        tickSize: 0,
        padding: 0,
        lineWidth: 0
      },
      gridline: {
        padding: -10,
        showExtend: true,
        dashArray: '10 10',
        width: 0.5,
        color: '#979797',
        altColor: '#000000',
        opacity: 0.8
      },
      title: {
        visible: true,
        text: null,
        hPosition: 'left',
        vPosition: 'top',
        hPadding: 20,
        vPadding: 10,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#535353',
        fontSize: '13px',
        fontWeight: '300',
        textAnchor: 'middle',
        SVG:
          "<text style='text-anchor:start'><tspan dy='0.7em'>PEER INVESTMENT (NO. OF MENTIONS)</tspan></text>"
      },
      label: {
        visible: false,
        color: '#000000',
        vPadding: -5,
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '300'
      },
      tooltip: {
        active: true,
        hPosition: 'shape', // shape, mouse, fixe
        vPosition: 'shape',
        hRelPosition: 'center',
        vRelPosition: 'up',
        // 'column' : ['cout','etp_contractuel','etp_ecart'],
        // 'columnSuffix' : [' ETP absence',' ETP contractuel',' ETP par rapport au indirect'],
        lineSeparator: true,
        fontFamily: 'Montserrat',
        padding: 0,
        color: '#535353', // '#FFFFFF'
        fontSize: '15px',
        fontWeight: '400',
        textAnchor: 'start',
        backgroundColor: '#ffffff', // '#535353',
        SVG:
          "<g><g><line x1='14' x2='14' y1='10' y2='90' style='stroke : #002380;stroke-width: 2' /></g><text x='10' y='14' dy='0.7em'><tspan x='25' y='20'>Investor Type : [investorType]</tspan><tspan x='25' y='60'>Peer : [peer]</tspan><tspan x='25' y='90'>No of Mentions : [count]</tspan></text></g>",
        variableFormat: {
          date: { datatype: 'date', formatIn: '%d/%m/%y', formatOut: '%B %e' }
        },
        tooltipSpecificFn: null
      },
      animation: {
        active: false,
        duration: 600,
        delay: 0,
        incrementalDelay: 0,
        ease: 'easeCubic' // default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      events: {
        mouseover: true,
        click: false
      }
    },
    contextualProperties: {
      tagId: 'ChartPeerInvest',
      dataIn: data,
      dataOut: null,
      d3viz: {
        dom: { viz: null, gridline: null, plot: null, axis: null, title: null },
        axis: {
          x: null,
          y: null,
          x2: null,
          y2: null,
          color: null,
          texture: null
        },
        barchart: { bandwidth: null }
      }
    }
  };

  function test2(data, action) {
    widgetRender(widgetProperties_US342, action);
  }

  /*   useEffect(() => {
    }, [loading]); */

  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        test2(data, 'init');
      }
    } else d3svg.current = true;
  }, [data, test2]);

  const handleChangeChart = (e, v) => {
    updateChart(widgetProperties_US342, filterObject(listOfDatesByDay()[v]));
  };

  return (
    <>
      <div
        ref={d3svg}
        className="bar-chart-container"
        id="ChartPeerInvest"
        role="img"
        style={{ width: '100%', height: '400px' }}>
        <SliderComponent handleChange={handleChangeChart} />
        {loading && (
          <h6>
            <LinearProgress />
          </h6>
        )}
        {error && <h4 style={{ color: 'red' }}>{error}</h4>}
      </div>
    </>
  );
};

export default ChartPeerInvest;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
